export type RoleFlagCasing = 'pascal' | 'camel';

const DEFAULT_ROLE_FLAGS = [
  'ViewOnlyCurrent',
  'GroupsViewCurrent',
  'RolesViewCurrent',
  'AccountViewCurrent',
  'BuildViewCurrent',
  'CoachViewCurrent',
  'AssignViewCurrent',
  'BuildCurriculumViewCurrent',
  'ManagePrepareEnrichCurrent',
  'BuildCurriculumView',
  'ManagePrepareEnrich',
  'ViewOnly',
  'AssessmentsView',
  'WorkflowsView',
  'GroupView',
  'TaskView',
  'RolesView',
  'BuildView',
  'AccountView',
  'GroupsView',
  'CoachView',
  'AssignView',
] as const;

function formatRoleKey(key: string, casing: RoleFlagCasing): string {
  if (casing === 'camel') {
    return key.charAt(0).toLocaleLowerCase() + key.slice(1);
  }
  return key;
}

function cleanRoles(roles: string[], append: string, casing: RoleFlagCasing): Record<string, boolean> {
  const roleObj: Record<string, boolean> = {};
  roles.forEach(role => {
    const normalized = formatRoleKey(role.split(' ').join('') + append, casing);
    roleObj[normalized] = true;
  });
  return roleObj;
}

function defaultRoleFlags(casing: RoleFlagCasing): Record<string, boolean> {
  return Object.fromEntries(DEFAULT_ROLE_FLAGS.map(flag => [formatRoleKey(flag, casing), false]));
}

export function buildRoleFlags(
  allRoles: string[],
  currentOrgRoles: string[],
  casing: RoleFlagCasing
): Record<string, boolean> {
  const all = cleanRoles(allRoles, '', casing);
  const current = cleanRoles(currentOrgRoles, 'Current', casing);
  return {
    ...defaultRoleFlags(casing),
    ...current,
    ...all,
  };
}
